//com.southvanmed/src/config.js
const config = {
  // ✅ Dynamic API endpoints using REACT_APP_* environment variables
  service: process.env.REACT_APP_API_URL || 'https://api.southvanmed.com',
  book_appointment: process.env.REACT_APP_BOOKING_URL || 'https://appointment.southvanmed.com',
  order_labtest: process.env.REACT_APP_LABTEST_URL || 'https://asklabtest.com',
  askmedication: process.env.REACT_APP_ASKMED_URL || 'https://askmedication.com',
  askmedApiHost: process.env.REACT_APP_ASKMED_API_URL || 'https://api.askmedication.com',
  immigration_url: process.env.REACT_APP_IMMIGRATION_URL || 'https://immigration.southvanmed.com',

  // ✅ Dynamic branding using REACT_APP_* environment variables
  clinicName: process.env.REACT_APP_CLINIC_NAME || 'South Vancouver Medical Clinic',
  service_email: process.env.REACT_APP_SERVICE_EMAIL || 'info@southvanmed.com',
  homepageUrl: process.env.REACT_APP_WEBSITE_URL || 'SouthVanMed.com',

  // ✅ Static configuration (same for all clinics)
  captcha_key: '6LcXWiwrAAAAAGGtQ5v5-nmPH7ti0W_hiyZ6WfQv',
  hasFamilyDoc: '1998',
  noFamilyDoc: '1999',
  askmedSecret: 'cXpMnLhQ*7#qX1i',
  stripePublicKey: 'pk_live_Fkqzpa0SU25HsqoCBbhBSYLD00rBmKxzRA',
  socialMedia: {
    // X (formerly Twitter) - Active
    x: {
      url: 'https://x.com/SouthVanMed',
      icon: 'fab fa-x-twitter', // Using Font Awesome X icon (FA 6.5.0)
      label: 'Follow us on X'
    },
    // YouTube - Future improvement (currently placeholder)
    youtube: {
      url: '#',
      icon: 'fab fa-youtube',
      label: 'Subscribe to our YouTube channel'
    }
    // Commented out other social media platforms
    // facebook: {
    //     url: 'https://facebook.com/southvanmed',
    //     icon: 'fab fa-facebook-f',
    //     label: 'Like us on Facebook'
    // },
    // instagram: {
    //     url: 'https://instagram.com/southvanmed',
    //     icon: 'fab fa-instagram',
    //     label: 'Follow us on Instagram'
    // },
    // linkedin: {
    //     url: 'https://linkedin.com/company/southvanmed',
    //     icon: 'fab fa-linkedin',
    //     label: 'Connect with us on LinkedIn'
    // },
    // pinterest: {
    //     url: 'https://pinterest.com/southvanmed',
    //     icon: 'fab fa-pinterest',
    //     label: 'Follow us on Pinterest'
    // }
  }
};
export default config;
